export default __webpack_public_path__ + "static/media/renewable.a0a9cfe7.svg";